/// <amd-module name="Work/Views/MyWork/Contracts/MyWorkSection" />
import { MyWorkItemsDecorated } from "Work/Views/MyWork/Contracts/MyWorkItemsDecorated";

export interface MyWorkSection {
    sectionKey: string;
    sectionName: string;
    items: MyWorkItemsDecorated[];
    isCollapsed: boolean;
    hasMore: boolean;
    count: number;
    isLoadingMore?: boolean;
}